var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExplicit = function SvgExplicit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.245 2.229C1 2.709 1 3.339 1 4.6v2.8c0 1.26 0 1.89.245 2.371.216.424.56.768.984.984C2.709 11 3.339 11 4.6 11h2.8c1.26 0 1.89 0 2.371-.245.424-.216.768-.56.984-.984C11 9.291 11 8.661 11 7.4V4.6c0-1.26 0-1.89-.245-2.371a2.25 2.25 0 0 0-.984-.984C9.291 1 8.661 1 7.4 1H4.6c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984Zm2.727.953V9h4.056V7.858h-2.65V6.662H7.82V5.517H5.378V4.324h2.65V3.182H3.972Z"
  })));
};
export default SvgExplicit;